// extracted by mini-css-extract-plugin
export default {"selected":"_040ccad425","un":"_0a1012b332"};